import React from 'react'
import styled from 'styled-components';
import { useSignFormStore } from 'src/stores/SignFormStore';
import { FormState } from 'src/stores/SignFormStore';
import { postUser } from 'src/api/User';

const NextButton = styled.button<{ disabled?: boolean }>`
  background: ${({ disabled }) =>
    disabled
      ? "gray"
      : "linear-gradient(180deg, #0AB2E4 0%, #06799B 65%, #00607C 100%)"};
  color: white;
  width: 100%;
  border: none;
  padding: 12px;
  border-radius: 8px;
  font-size: 16px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;

interface Props{
  children:React.ReactNode
  Check:boolean
  onResponse: (response: any) => void;
}

const isFormComplete = ({
  id,
  password,
  passwordConfirm,
  name,
  contact,
  email,
}: FormState) => {
  return [id, password, passwordConfirm, name, contact, email].every(
    (value) => typeof value === "string" && value.trim() !== ""
  );
};

const handlePostUser = async({id, password, passwordConfirm, name, contact, email}:FormState,onResponse:(response: any) => void)=>{
  //user_id,password,user_name,email,area_covered,phone,army_number
  const response = await postUser(id, password, name, email, '', contact);
  onResponse(response)
}


const ButtonSignUp = ({ children, Check, onResponse }: Props) => {
  // ✅ 개별 필드 값만 가져와서 상태 변경 최소화
  const { id, password, passwordConfirm, name, contact, email } = useSignFormStore();

  const isDisabled = !isFormComplete({ id, password, passwordConfirm, name, contact, email }) || !Check;

  const handleClick= async()=>{
    await handlePostUser({ id, password, passwordConfirm, name, contact, email }, onResponse);
  }
  

  return <NextButton 
            disabled={isDisabled}
            onClick={handleClick}
          >{children}</NextButton>;
};

export default ButtonSignUp;